import * as React from "react";
const SvgHeavyCheck = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 19, viewBox: "0 0 24 19", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M 20.285,0 9,11.567 3.714,6.556 0,10.272 9,19 24,3.715 Z" }));
export default SvgHeavyCheck;
